import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

interface IParams {
  catalogUid: string;
}

export const useUnArchiveCatalogQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ catalogUid }: IParams) => {
      await Api.products.unArchiveCatalog(catalogUid);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getCatalogs']);
      await client.invalidateQueries(['getCatalog']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getCatalogs']);
    },
  });
};
